import React, { useState, useEffect } from "react";
import { Header } from "../../components";
import Layout from "../layout/Layout";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase/firebase-config";
import "./home.scss";
import Paper from "@mui/material/Paper";
import Constant from "../../Constant";
import { getTransactions, update, getRevenue } from "../../services/orders";
import { fetchUsers } from "../../services/users";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import {
  FaRegEye,
  FaPencilAlt,
  FaAngleDoubleUp,
  FaAngleDoubleDown,
} from "react-icons/fa";
import Modal from "../../components/Modal";
import BeatLoader from "react-spinners/BeatLoader";
import EditTransactionForm from "./form";
import ViewTxnForm from "./form-view";
import { MdModeEditOutline } from "react-icons/md";
import { toast } from "react-toastify";
import { DynamicTableCell, useTableContext } from "../../contexts/TableContext";
import { APP_ENV } from "../../constants";

const columns = [
  {
    id: "type",
    label: "Type",
    minWidth: 80,
  },
  {
    id: "client",
    label: "Client ",
    minWidth: 80,
  },
  {
    id: "agent",
    label: "Agent ",
    minWidth: 80,
  },
  {
    id: "amount",
    label: "Amount",
    minWidth: 50,
  },
  {
    id: "fee",
    label: "Fee",
    minWidth: 40,
  },
  {
    id: "reference",
    label: "Reference",
    minWidth: 50,
  },
  {
    id: "status",
    label: "Status",
    minWidth: 50,
  },
  {
    id: "message",
    label: "Message/Reason",
    minWidth: 80,
  },
  {
    id: "created_at",
    label: "Created at",
    minWidth: 50,
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 50,
    align: "right",
  },
];

const TX_STATUSES = [
  "PENDING",
  "PROCESSING",
  "SUCCESS",
  "FAILED",
  "CANCELLED",
  "EXPIRED",
];

const TX_TYPES = [
  "AGENT_CASHOUT",
  "AGENT_DEPOSIT",
  "MOMO_CASHOUT",
  "MOMO_DEPOSIT",
  "MERCHANT_PAYMENT",
  "MERCHANT_DEPOSIT",
  "P2P_TRANSFER",
  "SEND_MONEY",
  "MAKE_PAYMENT",
  "DIRECT_PAY",
  "DIRECT_TRANSFER",
];

const EMPTY_FILTERS = {
  status: "",
  type: "",
  agent: "",
  start: "",
  end: "",
};

const Home = () => {
  const [user] = useAuthState(auth);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [transactions, setTransactions] = React.useState([]);
  const [totalCount, setTotalCount] = React.useState(0);
  const [exchanges, setExchanges] = React.useState([]);
  const [pendingCount, setPendingCount] = useState(0);
  const [processingCount, setProcessingCount] = useState(0);
  const [failedCount, setFailedCount] = useState(0);
  const [successCount, setSuccessCount] = useState(0);

  const [apiPendingAmount, setApiPendingAmount] = useState([]);
  const [apiSuccessAmount, setApiSuccessAmount] = useState([]);
  const [apiFailedAmount, setApiFailedAmount] = useState([]);
  const [apiProcessingAmount, setApiProcessingAmount] = useState([]);

  const [walletPendingAmount, setWalletPendingAmount] = useState([]);
  const [walletSuccessAmount, setWalletSuccessAmount] = useState([]);
  const [walletFailedAmount, setWalletFailedAmount] = useState([]);
  const [walletProcessingAmount, setWalletProcessingAmount] = useState([]);
  
  const [currentTransaction, setCurrentTransaction] = React.useState(null);
  const modalRef = React.useRef(null);
  const modalUpdateRef = React.useRef(null);
  const modalViewRef = React.useRef(null);
  const formRef = React.useRef(null);
  const txnFormUpdateRef = React.useRef(null);
  const [refresh, setRefresh] = React.useState(false);
  const { loading, setLoading } = useTableContext();
  const [authToken, setAuthToken] = useState("");
  const [draftFilters, setDraftFilters] = useState(EMPTY_FILTERS);
  const [appliedFilters, setAppliedFilters] = useState(EMPTY_FILTERS);
  const [merchantAgents, setMerchantAgents] = useState([]);

  const loadTransactions = (token, pageIndex = 0, pageSize = 10, filters = EMPTY_FILTERS) => {
    const offset = Number(pageIndex) * Number(pageSize);
    const limit = Number(pageSize) || 10;
    setLoading(true);
    getTransactions(token, { offset, limit, ...filters })
      .then((res) => {
        if (APP_ENV == "dev" || APP_ENV == "test"){
          console.log(`Using the token`);
          console.log(token);
        }
        if (res.status_code == 200) {
          setExchanges(res.data?.exchanges);
          setTransactions(res.data.transactions || []);
          setTotalCount(Number(res.data.total) || 0);
          setPendingCount(res.data.pendingCount);
          setProcessingCount(res.data.processingCount);
          setSuccessCount(res.data.successCount);
          setFailedCount(res.data.failedCount);
        } else if (
          res.status_code == 404 ||
          /no transactions/i.test(res.message || "")
        ) {
          setTransactions([]);
          setTotalCount(0);
        } else {
          setTransactions([]);
          setTotalCount(0);
          toast.error(`${res.message}`);
        }
      })
      .catch((err) => {
        toast.error(
          `Sorry, we could not retrieve txn at this time. Please try again`
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  const loadRevenue = (token) => {
    setLoading(true);
    getRevenue(token)
      .then((res) => {
        if (APP_ENV == "dev" || APP_ENV == "development" || APP_ENV == "test"){
          console.log(`Using the token`, token);
        }
        //get txns and set them
        if (res.status_code == 200) {
          try{
            //set revenue data
            setApiPendingAmount(res.data.api?.pendingAmount ?? []);
            setApiProcessingAmount(res.data.api?.processingAmount ?? []);
            setApiSuccessAmount(res.data.api?.successAmount ?? []);
            setApiFailedAmount(res.data.api?.failedAmount ?? []);
            //wallet amounts
            setWalletPendingAmount(res.data.wallet?.pendingAmount ?? []);
            setWalletProcessingAmount(res.data.wallet?.processingAmount ?? []);
            setWalletSuccessAmount(res.data.wallet?.successAmount ?? []);
            setWalletFailedAmount(res.data.wallet?.failedAmount ?? []);
          } catch(err) {
            console.log("Error parsing revenue data", err);
          }
        } else {
          //toast error message
          toast.error(`${res.message}`);
        }
      })
      .catch((err) => {
        toast.error(
          `Sorry, we could not retrieve txn at this time. Please try again`
        );
        //   console.log("ERROR: ", err);
      })
      .finally(() => {
        const timeID = setTimeout(() => {
          setLoading(false);
        }, 3000);
      });
  };

  const updateTransaction = async () => {
    if (!loading) {
      setLoading(true);
      let updateData = txnFormUpdateRef.current.getValues();
      updateData.id = currentTransaction.id;
      //update the txn
      update(updateData, authToken)
        .then((result) => {
          // console.log("Updated the transaction", result);
          toast(`${result.message}`);
        })
        .catch((err) => {
          //toast error message
          toast(
            `Sorry, we could not update this transaction. Please try again`
          );
        })
        .finally(() => {
          setLoading(false);
          setRefresh(!refresh);
        });
      txnFormUpdateRef.current.reinit();
      modalUpdateRef.current.close();
      setCurrentTransaction(null);
    }
    setLoading(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const updateDraftFilter = (key, value) => {
    setDraftFilters((prev) => ({ ...prev, [key]: value }));
  };

  const applyFilters = (event) => {
    if (event) event.preventDefault();
    if (draftFilters.start && draftFilters.end && draftFilters.start > draftFilters.end) {
      toast.error("Start date must be before end date");
      return;
    }
    setPage(0);
    setAppliedFilters({ ...draftFilters });
  };

  const clearFilters = () => {
    setDraftFilters(EMPTY_FILTERS);
    setAppliedFilters(EMPTY_FILTERS);
    setPage(0);
  };

  const handleView = (tx) => {
    modalViewRef.current.open();
    setCurrentTransaction(tx);
  };

  const closeViewTx = () => {
    modalViewRef.current.close();
  };

  const checkTransactionUpdate = () => {
    //notify if there's an update
    getTransactions(authToken)
      .then((result) => {
        if (result.data.length > transactions.length)
          toast.info(`You have new incoming transactions.`);
        console.log(`total orders`, transactions.length);
      })
      .catch((err) => {
        toast.error(`Sorry, we could not check transactions at this time.`);
        console.log("ERROR: ", err);
      });
  };

  useEffect(() => {
    if (!user) return;
    user.getIdToken(true).then((token) => {
      setAuthToken(token);
      loadRevenue(token);
      fetchUsers(token, { limit: 1000 })
        .then((res) => {
          if (res.status_code == 200) {
            const people = (res.data?.users || []).filter((u) =>
              ["MERCHANT", "AGENT"].includes(u.role?.name)
            );
            setMerchantAgents(people);
          }
        })
        .catch(() => {});
    });
  }, [refresh]);

  useEffect(() => {
    if (!authToken) return;
    loadTransactions(authToken, page, rowsPerPage, appliedFilters);
  }, [authToken, page, rowsPerPage, refresh, appliedFilters]);

  return (
    <Layout>
      <div className="md:mt-4 mx-10 sm:mt-20">
        <Header category="" title="Transactions Monitoring"></Header>
        <div>
          <div className="grid lg:grid-cols-12 md:grid-cols-8 sm:grid-cols-8 gap-6 mt-4">
            <div className="bg-[#fff] px-4 py-4 col-span-3 h-40 rounded-[10px]">
              <div className="text-center">
                <div className="col-span-2">
                  <p className="mb-2 text-[14px] __ellipsis">PENDING</p>
                  <h1 className="text-[40px] font-bold">{pendingCount}</h1>
                </div>
              </div>
            </div>

            <div className="bg-[#fff] px-4 py-4 col-span-3 h-40 rounded-[10px]">
              <div className="text-center">
                <div className="col-span-2">
                  <p className="mb-2 text-[14px] __ellipsis">PROCESSING</p>
                  {/* <Progress /> */}
                  <h1 className="text-[40px] font-bold">{processingCount}</h1>
                </div>
              </div>
            </div>

            <div className="bg-[#fff] px-4 py-4 col-span-3 h-40 rounded-[10px]">
              <div className="text-center">
                <div className="col-span-2">
                  <p className="mb-2 text-[14px] __ellipsis">FAILED</p>
                  {/* <Progress /> */}
                  <h1 className="text-[40px] font-bold">{failedCount}</h1>
                </div>
              </div>
            </div>

            <div className="bg-[#fff] px-4 py-4 col-span-3 h-40 rounded-[10px]">
              <div className="text-center">
                <div className="col-span-2">
                  <p className="mb-2 text-[14px] __ellipsis">SUCCESS</p>
                  {/* <Progress /> */}
                  <h1 className="text-[40px] font-bold">{successCount}</h1>
                </div>
              </div>
            </div>
          </div>

          <Header category="" title="Revenue - API"></Header>
          <div className="grid lg:grid-cols-12 md:grid-cols-8 sm:grid-cols-8 gap-6">
            <div className="bg-[#fff] px-2 py-2 col-span-3 h-40 rounded-[10px]">
              <div className="text-center">
                <div className="col-span-2">
                  <p className="mb-2 text-[14px] __ellipsis">PENDING</p>
                  { apiPendingAmount.map((item, index) => (
                    <div key={index}>
                      <span className="text-[16px] font-semibold">{item.currency}: </span>
                      <span className="text-[20px] font-bold">{item.amount.toFixed(2)}</span>
                    </div>
                  )) }
                </div>
              </div>
            </div>
            <div className="bg-[#fff] px-2 py-2 col-span-3 h-40 rounded-[10px]">
              <div className="text-center">
                <div className="col-span-2">
                  <p className="mb-2 text-[14px] __ellipsis">PROCESSING</p>
                  { apiProcessingAmount.map((item, index) => (
                    <div key={index}>
                      <span className="text-[16px] font-semibold">{item.currency}: </span>
                      <span className="text-[20px] font-bold">{item.amount.toFixed(2)}</span>
                    </div>
                  )) }
                  {/* <h1 className="text-[30px] font-bold">{apiProcessingAmount}</h1> */}
                </div>
              </div>
            </div>
            <div className="bg-[#fff] px-2 py-2 col-span-3 h-40 rounded-[10px]">
              <div className="text-center">
                <div className="col-span-2">
                  <p className="mb-2 text-[14px] __ellipsis">FAILED</p>
                  { apiFailedAmount.map((item, index) => (
                    <div key={index}>
                      <span className="text-[16px] font-semibold">{item.currency}: </span>
                      <span className="text-[20px] font-bold">{item.amount.toFixed(2)}</span>
                    </div>
                  )) }
                  {/* <h1 className="text-[30px] font-bold">{apiFailedAmount}</h1> */}
                </div>
              </div>
            </div>
            <div className="bg-[#fff] px-2 py-2 col-span-3 h-40 rounded-[10px]">
              <div className="text-center">
                <div className="col-span-2">
                  <p className="mb-2 text-[14px] __ellipsis">SUCCESS</p>
                  { apiSuccessAmount.map((item, index) => (
                    <div key={index}>
                      <span className="text-[16px] font-semibold">{item.currency}: </span>
                      <span className="text-[20px] font-bold">{item.amount.toFixed(2)}</span>
                    </div>
                  )) }
                  {/* <h1 className="text-[30px] font-bold">{apiSuccessAmount}</h1> */}
                </div>
              </div>
            </div>
          </div>

          <Header category="" title="Revenue - WALLET"></Header>
          <div className="grid lg:grid-cols-12 md:grid-cols-8 sm:grid-cols-8 gap-6">
            <div className="bg-[#fff] px-2 py-2 col-span-3 h-auto min-h-[5rem] rounded-[10px]">
              <div className="text-center">
                <div className="col-span-2">
                  <p className="mb-2 text-[14px] __ellipsis">PENDING</p>
                  <div className="max-h-32 overflow-y-auto">
                    { walletPendingAmount.map((item, index) => (
                      <div key={index}>
                        <span className="text-[16px] font-semibold">{item.currency}: </span>
                        <span className="text-[20px] font-bold">{item.amount.toFixed(2)}</span>
                      </div>
                    )) }
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-[#fff] px-2 py-2 col-span-3 h-auto min-h-[5rem] rounded-[10px]">
              <div className="text-center">
                <div className="col-span-2">
                  <p className="mb-2 text-[14px] __ellipsis">PROCESSING</p>
                  <div className="max-h-32 overflow-y-auto">
                    { walletProcessingAmount.map((item, index) => (
                      <div key={index}>
                        <span className="text-[16px] font-semibold">{item.currency}: </span>
                        <span className="text-[20px] font-bold">{item.amount.toFixed(2)}</span>
                      </div>
                    )) }
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-[#fff] px-2 py-2 col-span-3 h-auto min-h-[5rem] rounded-[10px]">
              <div className="text-center">
                <div className="col-span-2">
                  <p className="mb-2 text-[14px] __ellipsis">FAILED</p>
                  <div className="max-h-32 overflow-y-auto">
                    { walletFailedAmount.map((item, index) => (
                      <div key={index}>
                        <span className="text-[16px] font-semibold">{item.currency}: </span>
                        <span className="text-[20px] font-bold">{item.amount.toFixed(2)}</span>
                      </div>
                    )) }
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-[#fff] px-2 py-2 col-span-3 h-auto min-h-[5rem] rounded-[10px]">
              <div className="text-center">
                <div className="col-span-2">
                  <p className="mb-2 text-[14px] __ellipsis">SUCCESS</p>
                  <div className="max-h-32 overflow-y-auto">
                    { walletSuccessAmount.map((item, index) => (
                      <div key={index}>
                        <span className="text-[16px] font-semibold">{item.currency}: </span>
                        <span className="text-[20px] font-bold">{item.amount.toFixed(2)}</span>
                      </div>
                    )) }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <form className="txn-filters" onSubmit={applyFilters}>
          <div>
            <label htmlFor="tx-filter-status">Status</label>
            <select
              id="tx-filter-status"
              value={draftFilters.status}
              onChange={(e) => updateDraftFilter("status", e.target.value)}
            >
              <option value="">All</option>
              {TX_STATUSES.map((status) => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label htmlFor="tx-filter-type">Type</label>
            <select
              id="tx-filter-type"
              value={draftFilters.type}
              onChange={(e) => updateDraftFilter("type", e.target.value)}
            >
              <option value="">All</option>
              {TX_TYPES.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label htmlFor="tx-filter-agent">Merchant / Agent</label>
            <select
              id="tx-filter-agent"
              value={draftFilters.agent}
              onChange={(e) => updateDraftFilter("agent", e.target.value)}
            >
              <option value="">All</option>
              {merchantAgents.map((person) => (
                <option key={person.id} value={person.id}>
                  {(person.first_name || person.username || person.id) +
                    (person.role?.name ? ` (${person.role.name})` : "")}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label htmlFor="tx-filter-start">From</label>
            <input
              id="tx-filter-start"
              type="date"
              value={draftFilters.start}
              onChange={(e) => updateDraftFilter("start", e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="tx-filter-end">To</label>
            <input
              id="tx-filter-end"
              type="date"
              value={draftFilters.end}
              onChange={(e) => updateDraftFilter("end", e.target.value)}
            />
          </div>
          <div className="txn-filters-actions">
            <button type="submit" className="txn-filter-apply">
              Apply
            </button>
            <button
              type="button"
              className="txn-filter-clear"
              onClick={clearFilters}
            >
              Clear
            </button>
          </div>
        </form>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer
            sx={{ maxHeight: 500, minWidth: 600 }}
            style={{ boxShadow: "none" }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column, index) => (
                    <TableCell
                      key={column.id}
                      align="left"
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {transactions
                  .map((txn, index) => {
                    const curName = txn.currency?.name;
                    const currentExchange = exchanges?.find(
                      (exItem) => exItem.exchange_emit_currency == curName
                    );
                    const actualUsdValue =
                      txn.amount / txn.transaction_exchange_amount;
                    const currentUsdValue =
                      txn.amount / (currentExchange?.exchange_amount ?? 1);
                    // console.log('Current USD values VS Actual', currentUsdValue, actualUsdValue);
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                        <DynamicTableCell>
                          <TableCell align="left">{txn.type}</TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="left">
                            {txn.client?.first_name ?? ""} (
                            {txn.client?.username ?? ""})
                          </TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="left">
                            {txn.agent?.first_name || ""} (
                            {txn.agent?.username ?? ""})
                          </TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="left">
                            {txn.amount} {txn?.currency}
                            {actualUsdValue >= currentUsdValue ? (
                              <FaAngleDoubleDown color="#f00" />
                            ) : (
                              <FaAngleDoubleUp color="#0f0" />
                            )}
                            {Number(actualUsdValue - currentUsdValue).toFixed(
                              2
                            )}
                          </TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="left">
                            {txn.fee ?? 0}
                          </TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="left">{txn.request_data}</TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="left">{txn.status}</TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="left">{txn.message}</TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="left">
                            {new Date(txn.created_at).toDateString()},{" "}
                            {new Date(txn.created_at).toLocaleTimeString()}
                          </TableCell>
                        </DynamicTableCell>
                        <DynamicTableCell>
                          <TableCell align="center" key={index}>
                            <div className="flex gap-2">
                              <button
                                onClick={() => handleView(txn)}
                                className="bg-[#2DE2EE] rounded-full text-[#fff] p-2"
                                tooltip="View Txn"
                              >
                                <FaRegEye size={16} color="#000" />
                              </button>
                              <button
                                onClick={() => {
                                  setCurrentTransaction(txn);
                                  modalUpdateRef.current.open();
                                }}
                                className="bg-[#FFC106] rounded-full text-[#000] p-2"
                              >
                                <MdModeEditOutline size={16} color="#fff" />
                              </button>
                            </div>
                          </TableCell>
                        </DynamicTableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <BeatLoader
            color={Constant.spinner_color}
            loading={loading}
            cssOverride={{
              textAlign: "center",
              marginTop: "20px",
            }}
          />
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
        <Modal
          title={`Update Transaction - ${
            currentTransaction ? currentTransaction.id : ""
          }`}
          onSubmit={() => updateTransaction()}
          onClose={() => console.log("Closing form...")}
          ref={modalUpdateRef}
        >
          <EditTransactionForm
            ref={txnFormUpdateRef}
            data={currentTransaction}
          />
          <BeatLoader
            color={Constant.spinner_color}
            loading={loading}
            className="__center_spinner"
            cssOverride={{
              textAlign: "center",
              marginTop: "20px",
            }}
          />
        </Modal>
        <Modal
          title="Transaction Details"
          onSubmit={() => closeViewTx()}
          onClose={() => console.log("Closing form...")}
          submitBtn="Close"
          ref={modalViewRef}
        >
          <ViewTxnForm ref={txnFormUpdateRef} data={currentTransaction} />
        </Modal>
      </div>
    </Layout>
  );
};

export default Home;
